import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import it from './locales/it.json'

// Get stored language or default to 'en'
const storedLang = localStorage.getItem('language') || 'en'

const i18n = createI18n({
  legacy: false, // Set to false to use Composition API
  locale: storedLang,
  fallbackLocale: 'en',
  messages: {
    en,
    it
  },
  warnHtmlMessage: false,
  escapeParameter: false
})

export default i18n 